<template>
    <div>
        <ComponentHeader />
        <main>
            <HeroComponent title="About us"  img="images_work_line/work_main_bacground.png" position="30"/>
            <section class="lexsiaSection">
                <div class="lexsiaWrapper container">
                    <div class="lexsiaBody">
                        <h4>About PixYz Agency</h4>
                        <p>A team is a group of individuals (human or non-human) working together to achieve their goal. <br>
                            As defined by Professor Leigh Thompson of the Kellogg School of Management, "[a] team is a
                            group of people who are
                            interdependent with respect to information, resources, knowledge and skills and who seek to
                            combine their efforts to achieve a
                            common goal".A group does not necessarily constitute a team. Teams normally have members
                            with complementary skills <br>
                            and generate synergy <br>
                            through a coordinated effort which allows each member to maximize their strengths and
                            minimize their weaknesses. Naresh
                            Jain (2009) claims:
                            </p>
                            <p class="miniparagrphtext">
                            Team members need to learn how to help one another, help other team members realize their
                                true potential, and create an
                                environment that allows everyone to go beyond their limitations.
                            </p>
                            <p class="lastParagrphText">
                            While academic research on teams and teamwork has grown consistently and has shown a sharp
                            increase over the past recent
                            40 years, the societal diffusion of teams and teamwork actually followed a volatile trend in
                            the 20th century. The concept was
                            introduced into business in the late 20th century, which was followed by a popularization of
                            the concept of constructing teams.
                            Differing opinions exist on the efficacy of this new management fad. <br>
                            Some see "team" as a four-letter word: <span> </span> overused and under-useful.<br>
                            Others see it as a panacea that realizes the human-relations movement's desire to integrate
                            what that movement perceives as
                            best for workers and as best for managers. <br>
                            Still others believe in the effectiveness of teams, but also see them as dangerous because
                            of the potential for exploiting.<br> 
                            workers
                            — in that team effectiveness can rely on peer pressure and peer surveillance.<br>
                            However, Hackman sees team effectiveness not only in terms of performance: a truly effective
                            team will contribute to the
                            personal well-being and adaptive growth of its members.English-speakers commonly use the
                            word "team" in today's society to
                            characterise many types of groups. Peter Guy Northouse's book Leadership: theory and
                            practice<br>
                            discusses teams from a leadership perspective. According to the team approach to leadership,
                            a team is a type of
                            organizational group of people that are members. A team is composed of members who are
                            dependent on each other, work
                            towards interchangeable achievements, and share common attainments. A team works as a whole
                            together to achieve certain
                            things. A team is usually located in the same setting as it is normally connected to a kind
                            of organization, company, or
                            community. Teams can meet in-person (directly face-to-face) or virtually when practicing
                            their values and activities or duties. A
                            team's com </p>
                    </div>
                </div>
            </section>
        </main>
        <FooterCompinent />
    </div>
</template>

<script>

    import ComponentHeader from "@/components/Header.vue";
    import FooterCompinent from "@/components/Footer.vue";
    import HeroComponent from "@/components/HeroComonent.vue";

    export default {
        name: "AboutUsView",
        components: {
            ComponentHeader,
            FooterCompinent,
            HeroComponent
        }
    }
</script>

<style scoped lang="scss">
    .lexsiaSection {
        .lexsiaWrapper {
            .lexsiaBody {
                h4 {
                    font-size: 40px;
                    font-weight: 600;
                    line-height: -0.5px;
                    word-spacing: -2px;
                    margin-top: 86px;
                    margin-left: -8px;
                    color: #217a73;
                    text-align: center;
                }

                p {
                    max-width: 1360px;
                    margin: 0 auto;
                    line-height: 40px;
                    font-size: 24px;
                    margin-top: 35px;
                    color: #8a8a8a;
                    letter-spacing: 0px;
                }
                .miniparagrphtext {
                    margin: 40px auto;
                }
                .lastParagrphText {
                    max-width: 1380px;
                    padding-left: 11px;
                    margin-bottom: -7px;
                    span {
                        margin: 0 4.9px;
                    }
                }
                
            }
            
        }
    }
    @media only screen and (max-width: 500px) {
        .lexsiaSection {
            .lexsiaWrapper {
                .lexsiaBody {
                    h4 {
                        font-size: 30px;
                        font-weight: 500;
                        margin-top: 70px;
                        color: #217a73;
                        text-align: center;
                    }

                    p {
                        max-width: 90%;
                        text-align: center;
                        margin: 0 auto;
                        line-height: 1.9;
                        font-size: 14px;
                        margin-top: 40px;
                        color: #8a8a8a;
                        span {
                            display: block;
                            margin: 10px 0;
                        }
                    }
                }
            }
        }
    }
</style>